import { PickingPageState,  PickingRouteDetails } from "../../interfaces/Picking/Picking"

export const reducerInitialState = new PickingPageState();
reducerInitialState.isLoading = true;

type Action =
  | { type: 'SWITCH_SNACKBAR'; payload: boolean }
  | { type: 'SET_MESSAGE_COLOR'; payload: string }
  | { type: 'SET_MESSAGE_STATUS'; payload: string }
  | { type: 'PRODUCT_PICKED'; payload: boolean }
  | { type: 'PRODUCT_NOT_FOUND'; payload: boolean }
  | { type: 'PRODUCT_SKIP'; payload: boolean }
  | { type: 'PRODUCT_DETAILS_CHANGE'; payload: PickingRouteDetails }

export const PickingReducer = (
  state: PickingPageState,
  action: Action
) => {
  switch (action.type) {
    case 'SWITCH_SNACKBAR':
      return {
        ...state,
        openSnackbar: action.payload
      }
    case 'SET_MESSAGE_COLOR':
      return {
        ...state,
        messageColor: action.payload
      }
    case 'SET_MESSAGE_STATUS':
      return {
        ...state,
        messageStatus: action.payload
      }
    case 'PRODUCT_PICKED': {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case 'PRODUCT_NOT_FOUND': {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case 'PRODUCT_SKIP': {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case 'PRODUCT_DETAILS_CHANGE': {
      return {
        ...state,
        pickingRouteDetails: action.payload
      }
    }
    default:
      return state
  }
}
